<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level-1">
<span href="#/Text/9781611533088#_idParaDest-1" title="Link target outside of Sample">Title Page</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330881#_idParaDest-2" title="Link target outside of Sample">Copyright</span>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/TOC">Contents</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115330882#_idParaDest-3">Dedication</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115330883#_idParaDest-4">Acknowledgements</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/97816115330884#_idParaDest-5">Author’s Note</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330885#_idParaDest-6" title="Link target outside of Sample">Prologue</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330886#_idParaDest-7" title="Link target outside of Sample">Chapter 1</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330887#_idParaDest-8" title="Link target outside of Sample">Chapter 2</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330888#_idParaDest-9" title="Link target outside of Sample">Chapter 3</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/97816115330889#_idParaDest-10" title="Link target outside of Sample">Chapter 4</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/978161153308810#_idParaDest-11" title="Link target outside of Sample">The Peter Savage Series</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?038835f3